import React, { FC } from 'react'

import { Box, Tab, Tabs } from '@material-ui/core'
import { createStyles, makeStyles } from '@material-ui/core/styles'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'

import ContainerFull from '~/components/layouts/ContainerFull'
import useWizard from '~/components/shared/Wizard/useWizard'

import { useMobile } from '~/hooks/responsive'

import { Title } from '../Text'

import { WizardStep } from './types'

const useStyles = makeStyles(
  () =>
    createStyles({
      tab: {
        '& .MuiTab-wrapper': {
          flexDirection: 'row'
        }
      },
      tabMobile: {
        '& .MuiTab-wrapper': {
          flexDirection: 'column'
        }
      }
    }),
  { name: 'WizardNavigation' }
)

type TabLabelProps = {
  primary: string
  isMobile: boolean
}

const TabLabel: FC<TabLabelProps> = ({ primary, isMobile }) => (
  <Box ml={isMobile ? 0 : 2} textAlign="left">
    <Title
      color="inherit"
      as="p"
      fontSize={16}
      fontFamily="Nunito Sans, sans-serif"
      textTransform="none"
      fontWeight={500}
      textAlign="center"
    >
      {primary}
    </Title>
  </Box>
)

type WizardNavigationProps = {
  step: number
  completed: number
  onChange: (event: React.ChangeEvent<{}>, newValue: number) => void
  steps: WizardStep[]
  edit?: boolean
  isListingForm?: boolean
}

const checkIcon = <CheckCircleIcon width={20} height={20} color="primary" />

const WizardNavigation: FC<WizardNavigationProps> = ({
  completed,
  step,
  onChange,
  steps,
  edit,
  isListingForm
}) => {
  const classes = useStyles()
  const isMobile = useMobile()

  const { store } = useWizard()
  const cuttentSteps = edit ? steps.slice(0, -1) : steps.slice(0, -2)
  const mobileTabsVariant = isListingForm ? 'scrollable' : 'fullWidth'
  const tabsVariant = isMobile ? mobileTabsVariant : 'standard'

  return (
    <ContainerFull>
      <Box bgcolor="bg.primary.dark" color="text.primary">
        <Tabs
          value={step}
          onChange={onChange}
          indicatorColor="primary"
          textColor="inherit"
          centered
          variant={tabsVariant}
        >
          {cuttentSteps.map((tab, index) => {
            return (
              <Tab
                className={
                  isMobile && steps.length > 2 ? classes.tabMobile : classes.tab
                }
                key={index}
                label={
                  <TabLabel
                    primary={tab.name}
                    isMobile={isMobile && steps.length > 2}
                  />
                }
                icon={completed > index ? checkIcon : tab.icon}
                disabled={
                  step < index || (step !== index && store?.disableNavigation)
                }
              />
            )
          })}
        </Tabs>
      </Box>
    </ContainerFull>
  )
}

export default WizardNavigation
